import { forwardRef, Fragment } from 'react';
import { Target } from '@mews/enums';
import { LinkIcon, LinkStyled, StandaloneContainer } from './style';
import { LinkProps } from './types';

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
    (
        {
            as,
            children = null,
            disabled = false,
            inherit = false,
            overflowWrap = 'normal',
            size = 'normal',
            standalone = false,
            // ACCESSIBILITY: Inline links (non-standalone) without underlines are not accessible
            underline = true,
            wordBreak = 'normal',
            target = undefined,
            variant = 'default',
            icon,
            strong,
            ...other
        },
        ref
    ) => {
        const Container = standalone ? StandaloneContainer : Fragment;

        return (
            <Container>
                <LinkStyled
                    as={as}
                    disabled={disabled}
                    inherit={inherit}
                    overflowWrap={overflowWrap}
                    ref={ref}
                    size={size}
                    standalone={standalone}
                    variant={variant}
                    underline={underline}
                    wordBreak={wordBreak}
                    rel={target === Target.Blank ? 'noopener noreferrer' : undefined}
                    target={target}
                    strong={strong}
                    {...other}
                >
                    {children}
                    {icon ? <LinkIcon value={icon} size="small" /> : null}
                </LinkStyled>
            </Container>
        );
    }
);
